import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Upload } from 'components';
import { DownloadedItems } from '..';
import { content } from './content';
import { flattenDocs } from '../../utils';
import { isBeneficiary } from 'utils';

const DocsBeneficiary = ({ group }) => {
  const docs = useSelector(state => state.forms['documents']);
  const flatDocs = flattenDocs(docs);
  const viewMode = useSelector(state => state.forms.carrier.viewMode);
  const user = useSelector(state => state.user);

  return !viewMode && isBeneficiary(user?.groups) ? (
    <div className="mt-1">
      {content().map((item, index) => {
        return (
          // <Upload item={item} subFileCode={item.fileCode} key={index} group={'documents'} />
          <Upload
            item={{ ...item, label: `${item.label}\u00A0` }}
            subFileCode={item.fileCode}
            key={index}
            group={'documents'}
            showUploadList={{
              showRemoveIcon: true,
              showDownloadIcon: true,
              showPreviewIcon: true,
              showProgress: true,
            }}
          />
        );
      })}
    </div>
  ) : (
    <DownloadedItems content={content()} docs={flatDocs} />
  );
};

DocsBeneficiary.propTypes = {
  group: PropTypes.string.isRequired,
};

export default DocsBeneficiary;
